export interface GetBookbindingTargetMagazineCollectionsRequest {
  bibliographySetId: number
  volumeFrom: string
  volumeTo: string
  volumeNumberFrom: string
  volumeNumberTo: string
  volumeTotalFrom: string
  volumeTotalTo: string
  dateLabelFrom: string
  dateLabelTo: string
  holdingBranchCode: string
}

export function GetBookbindingTargetMagazineCollectionsRequestToJSON(
  value: GetBookbindingTargetMagazineCollectionsRequest
): any {
  return {
    bibliography_set_id:
      value.bibliographySetId !== 0 ? value.bibliographySetId : undefined,
    volume_from: value.volumeFrom !== '' ? value.volumeFrom : undefined,
    volume_to: value.volumeTo !== '' ? value.volumeTo : undefined,
    volume_number_from:
      value.volumeNumberFrom !== '' ? value.volumeNumberFrom : undefined,
    volume_number_to:
      value.volumeNumberTo !== '' ? value.volumeNumberTo : undefined,
    volume_total_from:
      value.volumeTotalFrom !== '' ? value.volumeTotalFrom : undefined,
    volume_total_to:
      value.volumeTotalTo !== '' ? value.volumeTotalTo : undefined,
    date_label_from:
      value.dateLabelFrom !== '' ? value.dateLabelFrom : undefined,
    date_label_to: value.dateLabelTo !== '' ? value.dateLabelTo : undefined,
    holding_branch_code:
      value.holdingBranchCode !== '' ? value.holdingBranchCode : undefined
  }
}
